<template>
    <div>
        <b-modal 
            no-stacking
            v-model="videoYoutube.show"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer  
            @hidden="videoYoutube.show = false" 
            size="lg"   
            body-class="p-0"
            header-class="p-2"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0 ml-2">
                    <div class="row align-items-center px-2">
                        <div class="col-12">
                            <h3>{{videoYoutube.title}}</h3>
                        </div>
                    </div>
                </div>
            </template>
            <div class="container-fluid pb-4 px-4">
                <div class="row">
                    <div class="col-12">
                        <iframe  :class="[`d-block w-100`]" height="423" :src="`https://www.youtube.com/embed/${videoYoutube.key}?autoplay=1`" 
                            :title="videoYoutube.title" frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

export default {
    name: "ModalVideoYouTube" ,
    props: {
        videoYoutube: Object,
    },
    data() {
        return {
        }
    },
    methods: {
    
    },
    computed: {
    }
}
</script>
<style scoped>

</style>